import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import queryString from 'query-string';

const ChartIframe = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 'none',
  margin: 'auto'
});

const Charts = ({ exchange, token, theme }) => {
  const chartParams = {
    exchange,
    token,
    login_id: localStorage.getItem('login_id'),
    web: true,
    login_token: localStorage.getItem('auth_token'),
    exchanges_subscribed: "NSE,BSE,NFO,MCX,CDS,BFO",
    theme: theme.palette.mode,
    color: theme.palette.background.paper
  };

  const qs = queryString.stringify(chartParams);
  const chartUrl = `/newcharts/?${qs}`;

  if (!chartUrl) return null;

  return (
    <Box sx={{
      width: '100%',
      height: '99%',
      p: 0
    }}>
      <ChartIframe
        src={chartUrl}
        title="TradingView Chart"
      />
    </Box>
  );
};

export default Charts; 